export default  {
    // Información dinámica que aparecerá en las vista "Acerca de" de la plataforma
    infoAcercaDe: {
        textoAcercaDe: "<strong class=\"f-24 c-accent principal-font-medium\">Nombre Organizacion</strong> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        imagenAcercaDe: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80",
        mision: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        vision: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        valores: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        consejoCoordinacion: [
            { nombre: "Nombre Persona", puesto: "Puesto Persona"}
        ],
        consejo: [
            { nombre: "Nombre Persona", puesto: "Puesto Persona"}
        ],
        imagenConsejo: "https://images.unsplash.com/photo-1522165078649-823cf4dbaf46?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80"

    },
    // Información dinámica que aparecerá en las vista "Login" de la plataforma
    infoLogin: {
        nombreOrganizacion: "Nombre Organización",
        lemaOrganizacion: "Lorem ipsum dolor sit amet",
        descripcionEnParrafos: [
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        ],
        enlaceWebsite: "https://direccionSition.dominio",
        nombreWebsite: "direccionSition.dominio"

    },
    // Información dinámica que define la fuente de información de los datos presentados en las vistas de: Contratos y Proveedores
    infoFuenteInformacion: {
        fuenteInformacion: "http://www.plataformadetransparencia.org.mx/"
    }
}